import { NgModule } from "@angular/core";
import { PurchaseHistoryRoutingModule } from "@onsip/web/features/accountSettings/purchaseHistory/purchase-history-routing.module";
import { PurchaseHistoryComponent } from "@onsip/web/features/accountSettings/purchaseHistory/purchase-history.component";
import { HeaderModule } from "@onsip/web/features/shared/components/layout/header/header.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    PurchaseHistoryRoutingModule,
    HeaderModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    TranslateModule,
    CommonModule,
    TableModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    CommonModule,
    LoadingContainerComponent
  ],
  declarations: [PurchaseHistoryComponent]
})
export class PurchaseHistoryModule {}
